import { Component, OnInit } from "@angular/core";
import { StatsService } from "src/app/services/stats/stats-service";
import { Game, Rest, Standings } from "src/app/models/games/games.models";
import { DatePipe } from "@angular/common";

import { CommonModule } from "@angular/common"; // Import CommonModule
import { firstValueFrom } from "rxjs";
@Component({
  selector: "app-tickets",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./tickets.component.html",
  styleUrl: "./tickets.component.scss",
})
export class TicketsComponent implements OnInit {
  gameDay: string = "";
  gameList: Game[] = [];
  winnerlistHome: any[] = [];
  winnerlistRoad: any[] = [];
  winnerlistSorted: any[] = [];
  pointsLeadersHome: any[] = [];
  assistsLeadersHome: any[] = [];
  rebondsLeadersHome: any[] = [];
  pointsLeadersRoad: any[] = [];
  assistsLeadersRoad: any[] = [];
  rebondsLeadersRoad: any[] = [];
  totalOdds = 0;
  totalOddsRoad = 0;
  totalOddsHome = 0;
  totalOddsWin = 0;
  totalOddsWinHome = 0;
  totalOddsWinRoad = 0;
  avgRealComboOddToday = 0;
  avgRealComboSampleDays = 0;
  avgRealComboMin = 0;
  avgRealComboMax = 0;
  constructor(private statsService: StatsService, private datePipe: DatePipe) {}

  async ngOnInit() {
    // Your initialization code here

    try {
      // Fetch the current game list
      const gameList = await firstValueFrom(
        this.statsService.getCurrentGameList(),
      );

      if (gameList.length > 0) {
        this.gameList = gameList;
        const matchCount = this.gameList.length;

        // ex: borne historique = saison courante si tu veux
        const avgCombo = await firstValueFrom(
          this.statsService.getAvgRealWinnersCombo(matchCount),
        );

        this.avgRealComboOddToday = avgCombo.avgComboOdd;
        this.avgRealComboSampleDays = avgCombo.sampleDays;
        this.avgRealComboMin = avgCombo.minComboOdd;
        this.avgRealComboMax = avgCombo.maxComboOdd;

        this.gameDay = new Date(gameList[0].date)
          .toLocaleString()
          .split(" ")[0];

        // Process each game in parallel
        await this.processPlayers(this.gameDay); // Ensure sequential processing if necessary
        for (const game of this.gameList) {
          await this.processGame(game); // Ensure sequential processing if necessary
        }
      }
    } catch (error) {
      console.error("Error initializing game data:", error);
    }
  }

  getColor(score1: number, score2: number) {
    if (score1 == null) {
      return "white";
    } else if (score1 > score2) {
      return "green";
      // return '#1E660A';
    } else {
      // return 'red';
      return "#992117";
    }
  }

  private async processGame(game: Game): Promise<void> {
    try {
      const [homeRanks, roadRanks, scoring, restHome, restRoad] =
        await Promise.all([
          firstValueFrom(
            this.statsService.getStandings(game.homeTeam, this.gameDay),
          ),
          firstValueFrom(
            this.statsService.getStandings(game.roadTeam, this.gameDay),
          ),
          firstValueFrom(this.statsService.getScoring(game.id)),
          firstValueFrom(
            this.statsService.getRest(game.homeTeam, this.datePipe.transform(game.date, 'MM/dd/yyyy')!),
          ),
          firstValueFrom(
            this.statsService.getRest(game.roadTeam, this.datePipe.transform(game.date, 'MM/dd/yyyy')!),
          ),
        ]);

      const { id, homeTeam, roadTeam, homeScore, roadScore } = game;
      const { home } = homeRanks;
      const { road } = roadRanks;
      const { averageHomePoints, averageRoadPoints } = scoring;

      // Determine the winner list and team details based on scoring averages
      const isHomeWinner = averageHomePoints > averageRoadPoints;
      const isWnba = game.isWnba

      const winnerList = isHomeWinner
        ? this.winnerlistHome
        : this.winnerlistRoad;
      const teamName = isHomeWinner ? homeTeam : roadTeam;
      const opponentName = isHomeWinner ? roadTeam : homeTeam;
      const teamScore = isHomeWinner ? homeScore : roadScore;
      const teamScoreProno = isHomeWinner
        ? averageHomePoints
        : averageRoadPoints;
      const opponentScore = isHomeWinner ? roadScore : homeScore;
      const opponentScoreProno = isHomeWinner
        ? averageRoadPoints
        : averageHomePoints;
      // const teamRank = isHomeWinner ? homeRanks.conference.ranks : roadRanks.conference.ranks;
      // const opponentRank = isHomeWinner ? roadRanks.conference.ranks : homeRanks.conference.ranks;
      const teamRank = isHomeWinner ? home.ranks : road.ranks;
      const opponentRank = isHomeWinner ? road.ranks : home.ranks;

      const odd = isHomeWinner ? game.homeOdd : game.roadOdd;
      const oddWin = homeScore > roadScore ? game.homeOdd : game.roadOdd;

      const noB2B = !restHome?.isBackToBack && !restRoad?.isBackToBack;
      const oneB2B = !!restHome?.isBackToBack || !!restRoad?.isBackToBack;

      const roadB2B = !!restRoad?.isBackToBack;
      const homeB2B = !!restHome?.isBackToBack;
      const road3N4 = (restRoad?.gamesLastFourDay ?? 0) >= 3;
      const home3N4 = (restHome?.gamesLastFourDay ?? 0) >= 3;

      const isHomeBet = isHomeWinner;
      const isRoadBet = !isHomeWinner;



      const winnerRest = isHomeWinner ? restHome : restRoad;
      const opponentRest = isHomeWinner ? restRoad : restHome;

      const winnerRestLabel = this.formatRest(winnerRest);
      const opponentRestLabel = this.formatRest(opponentRest);

      const isGoodOdd = +odd >= 2.05;

      const delta = isHomeWinner
        ? averageHomePoints - averageRoadPoints
        : averageRoadPoints - averageHomePoints;
      const deltaRank = opponentRank - teamRank;
      const totalScore = averageHomePoints + averageRoadPoints;

      let totalSignal = "";
      if (isWnba) {
        // Seuils recalibrés sur l'échelle WNBA (totaux ~170 vs ~220 en NBA)
        if (delta >= 6 && delta < 12) {
          totalSignal = "OVER";
        } else if (delta >= 15) {
          totalSignal = "UNDER_STRONG";
        }
        // entre 12 et 15 : zone grise (~50%, pas fiable) -> pas de signal
      } else {
        // NBA - logique d'origine inchangée
        if (delta >= 6) {
          if (totalScore <= 221 && delta >= 8) {
            totalSignal = "OVER_STRONG";
          } else if (totalScore <= 223 && delta >= 7) {
            totalSignal = "OVER";
          } else if (totalScore >= 239 && delta >= 8) {
            totalSignal = "UNDER_STRONG";
          } else if (totalScore >= 237 && delta >= 7) {
            totalSignal = "UNDER";
          }
        }
      }

      

      // Bonus continu sur le total autour de 230
      const totalBonus = Math.max(0, 1.6 - Math.abs(totalScore - 230) * 0.25);

      // Malus fatigue
      const b2bPenalty = oneB2B ? 2 : 0;

      // SCORE FINAL CONTINU + ARRONDI
      const confidenceScoreRaw = delta * 0.55 + totalBonus - b2bPenalty;
      const confidenceScore = Math.round(confidenceScoreRaw);

      // CATEGORIE
      const noFatigueWnba = !roadB2B && !homeB2B && !road3N4 && !home3N4;
      let confidenceTier = "";
      if (isWnba) {
        if (isRoadBet && +odd < 2.2 && noFatigueWnba) {
          confidenceTier = "PREMIUM";
        } else if (isHomeBet && +odd < 1.3 && noFatigueWnba) {
          confidenceTier = "ELITE";
        } else if (isHomeBet && +odd >= 1.3 && +odd < 1.8 && noFatigueWnba) {
          confidenceTier = "CORE";
        }
      } else {
        // NBA - logique d'origine inchangée
        if (confidenceScore >= 8) {
          confidenceTier = "ELITE";
        } else if (confidenceScore >= 6) {
          confidenceTier = "PREMIUM";
        } else if (confidenceScore >= 3) {
          confidenceTier = "CORE";
        }
      }

      let toPlay = false;
      if (!isWnba) {
        
          toPlay = 
          // B=FAUX B=FAUX; C=VRAI; D=FAUX; E=FAUX; U="home"
          (!roadB2B && homeB2B && !road3N4 && !home3N4 && isHomeBet) ||

          // B=FAUX; C=FAUX; D=VRAI; E=FAUX; U="home"
          (!roadB2B && !homeB2B && road3N4 && !home3N4 && isHomeBet) ||

          // B=FAUX; C=FAUX; D=FAUX; E=VRAI; U="road"
          (!roadB2B && !homeB2B && !road3N4 && home3N4 && isRoadBet)
      } else {
        toPlay = confidenceTier !== "";
      }
      
      const winnerPayload = {
        id,
        name: teamName,
        opponent: opponentName,
        win: teamScore > opponentScore,
        winByRank: teamRank < opponentRank,
        color: this.getColor(teamScore, opponentScore),
        delta,
        deltaRank,
        odd,
        oddWin,
        totalScore,
        totalRealScore: teamScore + opponentScore,
        predictionScore: confidenceScore,
        predictionScoreRaw: confidenceScoreRaw,
        confidenceScore,
        confidenceTier,
        toPlay,
        restHome,
        restRoad,
        totalSignal,
        noB2B,
        oneB2B,
        isHomeBet,
        teamScoreProno,
        opponentScoreProno,
        winnerRestLabel,
        opponentRestLabel,
      };

      winnerList.push({
        ...winnerPayload,
        predictionScore: confidenceScore,
      });

      this.winnerlistSorted.push({
        ...winnerPayload,
        home: isHomeWinner,
      });

      this.winnerlistSorted.sort(
        (a, b) => b.predictionScore - a.predictionScore,
      ); // Sort by delta in descending order
      this.totalOdds = this.winnerlistSorted.reduce(
        (product, winner) => product * winner.odd,
        1,
      );
      this.totalOddsRoad = this.winnerlistRoad.reduce(
        (product, winner) => product * winner.odd,
        1,
      );
      this.totalOddsHome = this.winnerlistHome.reduce(
        (product, winner) => product * winner.odd,
        1,
      );
      this.totalOddsWin = this.winnerlistSorted.reduce(
        (product, winner) => product * winner.oddWin,
        1,
      );
      this.totalOddsWinRoad = this.winnerlistRoad.reduce(
        (product, winner) => product * winner.oddWin,
        1,
      );
      this.totalOddsWinHome = this.winnerlistHome.reduce(
        (product, winner) => product * winner.oddWin,
        1,
      );
    } catch (error) {
      console.error(`Error processing game ${game.id}:`, error);
    }
  }

  private async processPlayers(gameDay: any) {
    try {
      const [topPlayersDay] = await Promise.all([
        firstValueFrom(this.statsService.getTopPlayers(this.gameDay)),
      ]);

      const { home, road } = topPlayersDay;
      // const { assistsLeadersHome, pointsLeadersHome, rebondsLeadersHome } = home;
      // const { assistsLeadersRoad, pointsLeadersRoad, rebondsLeadersRoad } = road;

      console.log(home);
      console.log(road);

      this.pointsLeadersHome = home.pointsLeaders;
      this.assistsLeadersHome = home.assistsLeaders;
      this.rebondsLeadersHome = home.rebondsLeaders;

      this.pointsLeadersRoad = road.pointsLeaders;
      this.assistsLeadersRoad = road.assistsLeaders;
      this.rebondsLeadersRoad = road.rebondsLeaders;
    } catch (error) {
      console.error(`Error processing Top players ${this.gameDay}:`, error);
    }
  }
     formatRest (rest: Rest) {
        if (!rest) return "";

        const btb = rest.isBackToBack ? "| B2B" : "| +1";
        return `${rest.gamesLastFourDay}N4 ${btb}`;
      }
}
